import { render } from "./DragAndDropArea.vue?vue&type=template&id=58ae864c&scoped=true"
import script from "./DragAndDropArea.vue?vue&type=script&lang=js"
export * from "./DragAndDropArea.vue?vue&type=script&lang=js"

import "./DragAndDropArea.vue?vue&type=style&index=0&id=58ae864c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ae864c"]])

export default __exports__